import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DropdownState_ById {
    data: {
        [key: number]: any[];
    };
}

const initialState: DropdownState_ById = {
    data: {},
};

const dropdownSlice_ById = createSlice({
    name: "dropdown",
    initialState,
    reducers: {
        setDropdown: (
            state,
            action: PayloadAction<{ key: number; data: any[] }>
        ) => {
            const { key, data } = action.payload;
            state.data[key] = data;
        },

        resetDropdown: (state) => {
            state.data = {};
        },
    },
});

export const dropdownActions_ById = dropdownSlice_ById.actions;
export default dropdownSlice_ById.reducer;